import React from 'react';
import styled from 'styled-components/macro';

const ShowPlanImageModal = React.memo(({ modalData, ...props }) => {
    return (
        <MainWrapper>
            <img src={modalData.options.imgUrl}></img>
        </MainWrapper>
    );
});

export default ShowPlanImageModal;

const MainWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
        object-fit: contain;
    }
`;
